export default {
  SET_TEAMS: function (state, payloads) {
    state.teams = payloads;
  },
};
